const mediumGames = [
  { id: '3', gTitle: 'Alhambra' },
  { id: '25', gTitle: 'Istanbul' },
  { id: '30', gTitle: 'Luxor' },
  { id: '28', gTitle: 'Medici' },
  { id: '15', gTitle: 'Saint Petersburg' },
  { id: '17', gTitle: 'Splendor' },
  { id: '19', gTitle: 'Thurn & Taxis' },
  { id: '20', gTitle: 'Ticket to Ride' },
];

export default mediumGames;
